import React from 'react';
import styled from 'styled-components';
import ClockIcon from '../../../../images/common/clock-grey.svg';
import Input from './Input';
import SingleSelect from './SingleSelect';
import { FlexContainer } from '../styles/FlexContainer';

type IProps = {
  textInputValue: string;
  dropdownValue: any;
  error: boolean;
  onTextChange: (value: any, isBlur: boolean) => void;
  onDropdownChange: (value: any) => void;
  className?: string;
  dropdownOptions: any[];
  isTime?: boolean;
  placeholderForTextInput?: string;
  errorMessage?: string;
};

interface StyledProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  style?: React.CSSProperties;
} 

const StyledTextInputWithDropdown = styled(FlexContainer)<StyledProps>`
  border: 1px solid #aaa;
  border-radius: 6px;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  width: 220px !important;
  height: 40px;
  gap: 8px;
  flex: unset;

  .text-input {
    border: none;
    outline: none;
    font-size: 16px;
    height: 100%;
    min-width: 50px;
    width: 105px !important;
    color: #555;
  }

  .dropdown-input {
    border: none;
    outline: none;
    background-color: transparent;
    font-size: 16px;
    cursor: pointer;
    position: relative;
    color: #555;
    width: auto !important;
    min-width: 50px;
    .header {
      width: auto !important;
      min-width: 50px;
    }
    .options-menu {
      transform: translate(-17px, 38px);
      padding-top: 5px;
    }
    .dropdown-option {
      line-height: 22px;
    }
  }
  /* &.charcoal-label-input {
        input.text-input {
            color: #aaa;
        }
        .dropdown-input .header {
            color: #aaa;
        }
        .options-menu {
            .dropdown-option {
                color: #aaa;
            }
        }
    } */
  &.dollar-input {
    padding-left: 0px;
    justify-content: space-between;
  }
  &.subscription-timezone {
    width: 160px !important;
    gap: 0px;
    input.text-input {
      height: 100%;
      width: 62px !important;
    }
    .options-menu {
      transform: translate(-13px, 30px);
    }
    .dropdown-input {
      .header {
        padding-left: 0px !important;
      }
      .select-header-span {
        padding-left: 0px !important;
      }
      .select-header-icon {
        display: none;
      }
    }
  }
  .timezone-clock {
    margin-left: 4px;
    img {
      height: 20px !important;
      width: 20px !important;
      margin-bottom: 1.5px;
    }
  }
`;
const StyledTextInputWrapper = styled.div`
  .error-message {
    color: #f00;
    margin: 0px;
    margin-block-start: 0em;
    margin-block-end: 0em;
    line-height: 16px;
  }
`;

const TextInputWithDropdown: React.FC<IProps> = ({
  textInputValue,
  dropdownValue,
  error,
  onTextChange,
  onDropdownChange,
  className,
  dropdownOptions,
  isTime = false,
  placeholderForTextInput = "0.00",
  errorMessage = "",
}) => {
  function textInput(
    type: "text",
    key: string,
    value: string | Date,
    placeHolder: string,
    hasError: boolean
  ) {
    key; 
    return (
      <Input
        placeholder={placeHolder}
        type={type}
        value={value}
        error={hasError}
        onChange={(e, isBlur) => onTextChange(e.target.value, isBlur || false)}
        className="text-input"
        maxLength={5}
        // errorMessage={errorMessage}
      />
    );
  }

  return (
    <StyledTextInputWrapper>
    <FlexContainer fxLayout="column">
      <StyledTextInputWithDropdown
        className={className}
        style={{ borderColor: error ? "#ff0000" : "" }}
      >
        {textInput(
          "text",
          "time",
          textInputValue,
          placeholderForTextInput,
          false
        )}
        <SingleSelect
          selectedKey={dropdownValue}
          nameKeys={["label"]}
          valueKeys={["value"]}
          options={dropdownOptions}
          customOption={(option) => <span>{option.value}</span>}
          onChange={(option: any) => onDropdownChange(option)}
          searchable={false}
          className="dpdn-no-border dropdown-input"
          // errorMessage={errorMessage}
        />
        {isTime && (
          <div className="timezone-clock">
            <img src={ClockIcon} />
          </div>
        )}
      </StyledTextInputWithDropdown>
      {errorMessage && <p className="error-message">{errorMessage}</p>}
    </FlexContainer>
  </StyledTextInputWrapper>)
};

export default TextInputWithDropdown;
